import Promise from '../lib/Promise.js';

class InstitutionNonFormSignInTask {
    static run(params) {
        return new InstitutionNonFormSignInTask(params).run();
    }

    constructor({env}) {
        this.env = env;
    }

    onError(error) {
        if (error.isAuthentication() && this.env.hasSimplyAnalyticsReferrer()) {
            this.env.getDialog('unknown-ip-dialog').show().then(() => this.env.openReferrer());
        }
        else if (error.isAuthentication() && !this.env.hasSimplyAnalyticsReferrer()) {
            this.env.openHomepage();
        }
        else if (error.isInactiveRegistration()) {
            this.env.showDialog('inactive-registration-dialog');
        }
        else if (error.isUnauthorizedLocation()) {
            this.env.getDialog('unauthorized-location-dialog').setMessage(error.getMessage()).show();
        }
        else {
            throw error;
        }
    }

    run() {
        return Promise.create(resolve => {
            this.env.getProxy()
                .getInstitution({referrer: this.env.getReferrer()})
                .then(data => resolve(data))
                .catch(error => this.onError(error));
        });
    }
}

export default InstitutionNonFormSignInTask;